// action - state management

import * as actionTypes from './actions';

export const initialState = {
    authenticated: false,
    loading: false,
    user: null,
    error: null,
    authenticationMethod: null
};

// ==============================|| USER REDUCER ||============================== //

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_USER_ERROR:
            return {
                ...state,
                error: action.error
            };
        case actionTypes.SET_AUTHENTICATED:
            return {
                ...state,
                authenticated: true,
                user: null,
                loading: false
            };
        case actionTypes.SET_UNAUTHENTICATED:
            return {
                ...state,
                authenticated: false,
                user: null,
                authenticationMethod: null
            };
        case actionTypes.SET_USER:
            return {
                ...state,
                authenticated: true,
                user: action.user,
                loading: false
            };
        case actionTypes.STOP_LOADING_USER:
            return {
                ...state,
                loading: false
            };
        case actionTypes.LOADING_USER:
            return {
                ...state,
                loading: true
            };
        case actionTypes.SET_AUTHENTICATION_METHOD_SSO:
            return {
                ...state,
                authenticationMethod: 'SSO'
            };
        case actionTypes.SET_AUTHENTICATION_METHOD_IDM:
            return {
                ...state,
                authenticationMethod: 'IDM'
            };
        case actionTypes.SET_AUTHENTICATION_METHOD_LOCAL:
            return {
                ...state,
                authenticationMethod: 'LOCAL'
            };
        case actionTypes.SET_AUTHENTICATION_METHOD_VIISP:
            return {
                ...state,
                authenticationMethod: 'VIISP'
            };
        default:
            return state;
    }
};

export default userReducer;